import { api } from '../api/client.js';
let sent = 0;
export function trackProduct(event: string, durationMs = 0) {
  if (navigator.doNotTrack === '1' || sent >= 100) return;
  sent++;
  void api.metric(event, Math.max(0, Math.min(180000, durationMs))).catch(() => {});
}
